$('.js-accordion-title').click(function(e) {
  $(this).toggleClass('is-open');
  $(this).next().slideToggle(200);
  $(this).next().toggleClass('is-open');
});
